
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z","fill":"#FF1515"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.528 20.389c.782 0 1.416-.634 1.416-1.417V18.5h.236a.708.708 0 00.709-.709v-4.25a.708.708 0 00-.709-.708h-.236v-.472c0-.782-.634-1.417-1.416-1.417H8.417c-.783 0-1.417.635-1.417 1.417v6.611c0 .782.634 1.417 1.417 1.417h15.11zm-.473-1.89H8.89v-5.666h14.166v1.89H24v1.888h-.945V18.5zm-9.444-4.721v3.777H9.833v-3.777h3.778z","fill":"#fff"}})])
          )
        }
      }
    